"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Context = void 0;
const errors_1 = require("./errors");
const walkers_1 = require("./walkers");
class Context {
    constructor(...args) {
        this.pattern = '';
        this._variables = new Map();
        this._index = 0;
        this._anonymousVariableCounter = 0;
        if (typeof args[0] === 'string') {
            let [pattern, date, env] = args;
            this.pattern = pattern;
            this.date = date;
            if (env) {
                for (let entry of env) {
                    this._variables.set(...entry);
                }
            }
        }
        else if (args[0] instanceof Context) {
            let [context, pattern] = args;
            this.date = context.date;
            this._variables = context._variables;
            this._anonymousVariableCounter = context._anonymousVariableCounter;
            this.pattern = pattern;
        }
    }
    get index() {
        return this._index;
    }
    get(delta = 0) {
        return this.pattern[this.index + delta];
    }
    next() {
        this._index++;
    }
    evaluate(pattern) {
        return walkers_1.parsePattern(new Context(this, pattern));
    }
    getValueOfVariable(name) {
        let storage = this._variables.get(name);
        if (storage) {
            if (storage.isTemplateMode) {
                return this.evaluate(storage.value);
            }
            else {
                return storage.value;
            }
        }
        else {
            errors_1.throwNotDefinedError(this, name);
        }
    }
    getLiteralValueOfVariable(name) {
        let storage = this._variables.get(name);
        if (storage) {
            return storage.value;
        }
        else {
            errors_1.throwNotDefinedError(this, name);
        }
    }
    setVariable(name, value, isTemplateMode = false) {
        if (name == '') {
            name = `!${this._anonymousVariableCounter++}`;
        }
        this._variables.set(name, { isTemplateMode, value });
        return name;
    }
}
exports.Context = Context;
